module.exports = __webpack_public_path__ + "static/ConversationsCoppice8bitcopy-34f20e9a3a7cd9f98c45ee7de1ccb6c5.png";